import { render, staticRenderFns } from "./IconPaperPlane.vue?vue&type=template&id=e6661538"
import script from "./IconPaperPlane.vue?vue&type=script&lang=js"
export * from "./IconPaperPlane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports